import styled from "styled-components";
import { IMAGES } from "../../../constants/images";
import SearchBar from "./SearchBar";
import { useEffect } from "react";
import MenuIcon from "../Icons/MenuIcon";
import CloseIcon from "../Icons/CloseIcon";

export default function SatelliteDrawControls({ toggleDrawModeArea, toggleDrawModeHome, drawMode, clearHandler, isOpenMenu, handleOpenMenu }) {
  const handleResize = () => {
    if (window.innerWidth < 768) {
      handleOpenMenu(false);
    } else {
      handleOpenMenu(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCloseMenu = (callback) => {
    callback();
    if (window.innerWidth < 768) handleOpenMenu(false);
  };

  return (
    <>
      <ToggleDrawButton onClick={() => handleOpenMenu(!isOpenMenu)}>{isOpenMenu ? <CloseIcon /> : <MenuIcon />}</ToggleDrawButton>
      {isOpenMenu && (
        <SatelliteContainer>
          <div className="search">
            <SearchBar />
          </div>
          <div className="satellite-buttons">
            <button
              onClick={() => handleCloseMenu(toggleDrawModeArea)}
              className={drawMode.area === "draw_polygon" ? "satellite-controls-button active" : "satellite-controls-button"}
            >
              <span>
                <img className="button-img" src={IMAGES.HOME} alt="home" />
              </span>{" "}
              Draw Lot Perimeter
            </button>
            <button
              onClick={() => handleCloseMenu(toggleDrawModeHome)}
              className={drawMode.home === "draw_polygon" ? "satellite-controls-button active" : "satellite-controls-button"}
            >
              <span>
                <img className="button-img" src={IMAGES.HOME} alt="home" />
              </span>{" "}
              Draw Asset Contour
            </button>

            <button onClick={clearHandler} className="satellite-controls-button">
              <span>
                <img className="button-img" src={IMAGES.CLEAR} alt="bin" />
              </span>{" "}
              Clear
            </button>
          </div>
        </SatelliteContainer>
      )}
    </>
  );
}

const ToggleDrawButton = styled.button`
  all: unset;
  position: absolute;
  top: 15px;
  left: 15px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;

  @media (min-width: 768px) {
    display: none;
  }
`;

const SatelliteContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  padding: 10px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 15px;
  width: 263px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 2;

  .search {
    border-bottom: 1px solid rgba(0, 0, 0, 1);
  }

  .satellite-buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .satellite-controls-button {
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    width: 90%;
    height: 24px;
    color: #fff;
    font-weight: 700;
    background-color: rgba(0, 0, 255, 1);

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 100%;
      background-color: rgba(0, 0, 255, 1);
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    &.active {
      background-color: #007bff;
      color: #fff;
      &:hover {
        background-color: #268fff;
      }
    }
  }

  .satellite-controls .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 10px;
    font-size: 12px;
  }

  .button-img {
    width: 14px;
  }

  button {
    background-color: #f7f7f7;
    border: 1px solid rgba(0, 0, 255, 1);
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 0;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    left: 55px;
  }
`;
